import * as analytics from './modules/analytics';
import * as languageSwitcher from './modules/language-switcher';
import * as menus from './modules/menus';
import * as personalDetails from './modules/personal-details';

import type { Panel } from '@/common/global.interfaces';
import unitTestsView from '@/features/unit-tests-view/store';
import user from '@/features/user/store';
import { prefStorage } from '@samknows/utils';
import Vue from 'vue';
import Vuex from 'vuex';

// Make vue aware of Vuex
Vue.use(Vuex);

export interface RootState {
  panel: Panel;
}

// Combine the initial state and the mutations to create a Vuex store.
const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',

  state(): RootState {
    return {
      panel: prefStorage.get<Panel>('panel', {} as Panel)
    };
  },

  mutations: {
    setPanel(state: RootState, panel: Panel) {
      state.panel = panel;
      prefStorage.set('panel', panel, true);
    }
  },

  modules: {
    analytics,
    languageSwitcher,
    menus,
    personalDetails,
    unitTestsView,
    user
  }
});

export default store;
